'use client';
import PropTypes from 'prop-types';
import {useFormContext} from 'react-hook-form';
import {IconX} from '@tabler/icons-react';
import {Box, Button, FormHelperText, Grid, InputAdornment} from '@mui/material';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
import {RHFTextField} from '@/shared/components/forms/theme-elements/form/RHFTextField';
import IconifyIcon from '../../../utilities/ReactIcon';

export const SellingPoints = ({name, values, errors}) => {
  const {control, setValue} = useFormContext();

  const removeSellingPoint = (index) => {
    setValue(
      name,
      (values || []).filter((_, ind) => ind !== index)
    );
  };

  const addSellingPoint = () =>
    setValue(name, [
      ...(values || []),
      {
        icon: '',
        text: {
          en: '',
          nl: '',
        },
      },
    ]);

  return (
    <Grid mt={2}>
      {values?.map((sellingPoint, index) => {
        return (
          <Grid
            key={sellingPoint.id || `sellingPoint-${index}`}
            display={'flex'}
            flexWrap={'wrap'}
            spacing={1}
            container
          >
            <Grid item md={3}>
              <RHFTextField
                control={control}
                name={`${name}[${index}].icon`}
                error={errors?.[name]?.[index]?.icon}
                label={'Icon'}
                mb={0}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <Box mt={0.5} mr={1}>
                        <IconifyIcon
                          icon={`mdi:${values?.[index]?.icon || 'info'}`}
                        />
                      </Box>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item md={7}>
              <RHFMultilingualField name={`${name}[${index}].text`} />
            </Grid>

            <Grid item md={2}>
              <Button
                color='error'
                fontWeight={600}
                textAlign={'right'}
                sx={{
                  float: 'right',
                  height: '67%',
                  cursor: 'pointer !important',
                }}
                onClick={() => removeSellingPoint(index)}
              >
                <IconX />
              </Button>
            </Grid>
          </Grid>
        );
      })}

      <center>
        <Button size='small' color={'error'} onClick={() => addSellingPoint()}>
          Add New Selling Point
        </Button>
      </center>

      {errors && (
        <FormHelperText sx={{color: 'error.main', ml: -0.01, mb: 1}}>
          {errors?.message}
        </FormHelperText>
      )}
    </Grid>
  );
};

SellingPoints.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.array,
  errors: PropTypes.object,
};
